import React from 'react';
import { theme } from './theme';

// New (Sep 16, per Ali's report — real gap: there was zero password
// strength requirement anywhere, client or server; Supabase's own bare
// platform default is just 6 characters with no complexity rule at
// all, so something like "123456" was genuinely accepted). Minimum 8
// characters, at least one letter, at least one number — deliberately
// NOT requiring a symbol too; that tends to push people toward
// predictable substitutions ("Password1!") rather than meaningfully
// stronger passwords, for real friction in return.
//
// This is the CLIENT-side half only. Supabase's own Authentication →
// Policies → Password Requirements should be set to the same rule
// (min length 8, require a letter and a number) so a direct API call
// bypassing this form can't skip it — same defense-in-depth pattern
// already used for budget/date/passenger validation elsewhere in this
// app.
export function checkPasswordStrength(password) {
  const checks = {
    length: password.length >= 8,
    hasLetter: /[a-zA-Z]/.test(password),
    hasNumber: /[0-9]/.test(password),
  };
  return { valid: checks.length && checks.hasLetter && checks.hasNumber, checks };
}

export const PASSWORD_REQUIREMENTS_MESSAGE = 'Password must be at least 8 characters and include at least one letter and one number.';

// Live checklist, not just a single pass/fail message (Sep 16, per
// Ali's report — "at all levels," both signup and change/reset
// password get the exact same component, so requirements never read
// differently depending on which screen someone's on). Renders
// nothing at all for an empty password — no reason to show a wall of
// red X's before someone's typed anything.
export function PasswordStrengthMeter({ password }) {
  if (!password) return null;
  const { checks } = checkPasswordStrength(password);

  const Row = ({ met, label }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: met ? theme.success : theme.textMuted }}>
      <span style={{ fontWeight: 700 }}>{met ? '✓' : '○'}</span>
      <span>{label}</span>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', marginTop: '6px', marginBottom: '10px' }}>
      <Row met={checks.length} label="At least 8 characters" />
      <Row met={checks.hasLetter} label="At least one letter" />
      <Row met={checks.hasNumber} label="At least one number" />
    </div>
  );
}